import { Component, OnInit } from '@angular/core';
declare var $: any;
import { ApiService } from '.././api.service';
import { Router } from '@angular/router';
import { AppComponent } from '../app.component';
import { formatDate } from '@angular/common';
@Component({
  selector: 'app-order',
  templateUrl: './order.component.html',
  styleUrls: ['./order.component.scss']
})
export class OrderComponent implements OnInit {

  arre: any;
  arre00: any;
  show = false;
  add: any = false;
  update: any = false;
  delete: any = false;
  name: any;
  email: any;
  password: any;
  adress: any;
  root: any;
  phone: any;
  control: any;
  rootA: any;
  controlA: any;
  nameU: any;
  emailU: any;
  passwordU: any;
  adressU: any;
  rootU: any;
  phoneU: any;
  controlU: any;
  idUp: any;
  searchName: any;
  rootSearch = 'أبحث بالفرع';
  controlSearch = 'أبحث بالصلاحية';
  notes: any;
  pay: any;
  idDS: any;
  nameD: any;
  idUS: any;
  payU: any;
  notesU: any;
  country: any;
  countryU: any;
  items: any = undefined;
  payment: any;
  paymentno: any;
  discound: any;
  submit = false;
  submitNumber = true;
  itemsGo: any;
  payGo: any;
  notesGo: any;
  dataGo: any;
  arre0987: any;
  arrayclose: any;
  idItem: any;
  arreCustomer:any;
  Customer: any = 'Customer';
  QUotationNo: any = 'QUotation No';
  choose = false;
  qty: any;
  goQty0 = false;
  QtyAvaliable: any = [];
  rootB: any = undefined;
  arrImage: any;
  qwss = false;
  qtySearch: any;
  paySearch: any;
  itemGo: any;
  amount: any = 0;
  dateAm: any;
  dateAmOrder: any;
  customer_id: any;
  serchCodeVisit: any = null;
  cityU: any;
  areaU: any;
  typeU: any = '';
  phone2U: any;
   www: any;
   goImg: any = false;
   arreCustomer00: any;
   nameUX: any;
   nameUX0: any;
   arreCustomer000: any;
   discoundAll: any;
   payAll: any;
   payAll0: any;
   mo0: any;
   mo01: any;
   id_item: any;
   yarbs: any = null;
   yarbs0: any = false;
   ost: any = 'Qty';
   upS: any = true;
   upS0: any = false;
   date: any;
   PaymentWay: any;
   countImage: any;
   images: any = '';
   nameU0: any;
   emailU0: any;
   phoneU0: any;
   adressU0: any;
   idUS0: any;
   cityU0: any;
   phone2U0: any;
   commision: any;
   commisionafter: any;
   alltotal: any;
   payAll00: any;
   discoundAllValue: any;
   price: any;
   priceSeller: any;
   quota: any;
   choose2: any = false;
   Price_Seller: any = 'Price_Seller';

  constructor(private _ApiService: ApiService , private _Router: Router, private _AppComponent: AppComponent ) {
    this._AppComponent.activeU = '';
    this._AppComponent.activeR = '';
    this._AppComponent.activeS = '';
    this._AppComponent.activeI = '';
    this._AppComponent.activeC = '';
    this._AppComponent.activeP = '';
    this._AppComponent.activeCu = '';
    this._AppComponent.activeCR = '';
    this._AppComponent.activeH = '';
    this._AppComponent.activeO = '';
    this._AppComponent.activeCE = '';
    this._AppComponent.activeCV = '';
    this._AppComponent.activeSE = '';
    this._AppComponent.activeSEB = '';
    this._AppComponent.activeCuO = 'active';
    this._AppComponent.activeCuOStore = '';
    this._AppComponent.activeHRE = '';
    this._AppComponent.activeHReport = '';
    this._AppComponent.activeCVV = '';
    this._AppComponent.activeCVEm = '';
    this._AppComponent.activeCVEmAttendances = '';
    this._AppComponent.activeCVEmAttendancesSalary = '';
    this._AppComponent.activeCVEmPermession = ''
    this._AppComponent.activeHReportAccounts = '';
    this._AppComponent.activeHReportCashPayments = '';
    this._AppComponent.activeCashReceipts = '';
    this._AppComponent.activeDailyRestrictions = '';
    this._AppComponent.activeGeneralReports = '';
    this._AppComponent.activeHReportPrivate = '';
    this._AppComponent.activeHReportPrivatePaymentsReport = '';
    this._ApiService.allCustomerNot().subscribe((res)=>{
      if(res.check === true){
        this.arre = res.data;
        this.ngOnInit();
        $(`.loading`).css({display: 'none'})
      } else{
        $(`.loading`).css({display: 'none'})
        alert('error')
      }
    })
    this._ApiService.allSC0sBId().subscribe((res)=>{
      if(res.check === true){
        this.arreCustomer000 = res.data;
      } else{
        $(`.loading`).css({display: 'none'})
        alert('error')
      }
    })
    this._ApiService.allSC0sId().subscribe((res)=>{
      if(res.check === true){
        this.arreCustomer00 = res.data;
      } else{
        $(`.loading`).css({display: 'none'})
        alert('error')
      }
    })
    this._ApiService.allSC0Id().subscribe((res)=>{
      if(res.check === true){
        this.arreCustomer = res.data;
      } else{
        $(`.loading`).css({display: 'none'})
        alert('error')
      }
    })
    this._ApiService.Profile().subscribe((res)=>{
      if(res.check === true) {
        res.data.forEach((element: any) => {
          if(element.name == 'Orders') {
            if(element.	add_permission === 1) {
              this.add = true;
            }
            if(element.	update_permission === 1) {
              this.update = true;
            }
            if(element.	delete_permission === 1) {
              this.delete = true;
            }
          }

        });
        this._AppComponent.refreshNotification()
        this.show = true;
      } else {
        this._Router.navigate([''])
        this.show = false;
      }
    })
   }
   ref(){
    this.dateAm = ''; this.amount = ''; this.payAll0 = ''; this.discoundAll = ''; this.payAll = '';this.dateAmOrder = '';
    $('.select2Q').val('undefined').trigger('change.select2');
    $('.loading').css({display: 'block'});
    setTimeout(() => {
      $('.loading').css({display: 'none'});
    }, 100);
     this.yarbs = null;
     this.yarbs0 = false;
     $('.select2Q').removeAttr('disabled');
     $('.goQN').val('undefined').trigger('change.select2');
     this.upS = true;
     this.upS0 = false;
     this.nameU0 = '';
     this.nameU = '';
     this.phoneU = '';
     this.phone2U = '';
     this.typeU = '';
     this.adressU = '';
     this.phoneU0 = '';
     this.idUS0 = '';
     $('.goQN00').val('undefined').trigger('change.select2');
     $('.goQN00X0').val('undefined').trigger('change.select2');
     this.arre00 = [];
     $('.delall').css({display: 'none'})
     this.alltotal = '';
     this.payAll00 = '';
     this.discoundAllValue = '';
     this.discoundAll = '';
     this.payAll = '';
     this.alltotal = '';
     this.alltotal = '';
     this.commision = '';
     this.commisionafter = '';

   }
  items0Orderre(){
    $('.loading').css({display: 'block'});
    this._ApiService.ordertore({id: $('.select2Q').val()}).subscribe((res)=> {
      this._ApiService.allCustomerNot().subscribe((res)=>{
        if(res.check === true){
          this.arre = res.data;
        } else{
          $(`.loading`).css({display: 'none'})
          alert('error')
        }
      })
      this.ref()
      $('.loading').css({display: 'none'});
    })

  }
  showpho(data: any){
    if (window.matchMedia('(max-width: 500px)').matches) {

  } else {
    $('.loading').css({display: 'block'});
    this._ApiService.allIm({id: data}).subscribe((res)=>{
      if(res.data.length == 0) {
        alert('There are no images for this Item. Please go put pictures for this Item');
        $('.loading').css({display: 'none'});
      } else{
        this.arrImage = res.data;
        this.qwss = true;
        $('#updPho').css({display: 'block'});
        $('.loading').css({display: 'none'});
      }
    })
  }
  }
  goPic(v: any){
    this.goImg = true;
    this.www = v;
  }
  goPic0(){
    this.goImg = false;
    this.www = '';
  }
  printall(){
    var cnt = $("#parentDelete").contents();
    $("#parentDelete").replaceWith(cnt);
    $("#parentDelete1").removeAttr('width')
    this.Price_Seller = 'Price';
    this.items0("l" , ()=>{
      this.quota = $('.select2Q').val();
      $('.choose2').show();
      $('.choose3').hide();
      $('.prinee').css({borderRight: '1px solid black' });
      this.choose2 = true;
      setTimeout(() => {
        window.print();
        $('.choose2').hide();
      $('.choose3').show();
      this.choose2 = false;
      this.Price_Seller = 'Price_Seller';
      $("#parentDelete1").attr('width' , '100%')
      $('#parentDelete1').wrap("<a id='parentDelete' style='overflow: auto;height: 40vh;width:100%;'></a>");
      }, 500);
      })
  }
  items0(id: any , action: any = null){
    if(action != null) {
      if($('.select2Q').val() == 'undefined' || $('.select2Q').val() == undefined || $('.select2Q').val() == '' || $('.select2Q').val() == null){
        alert('Plz Choose QUotation No');
      } else{
      this.idItem = id;
      $('.loading').css({display: 'block'});
      this._ApiService.getItemBooked({id: $('.select2Q').val()}).subscribe((res)=>{
        this.arre0987 = res;
        // $('#upd023').css({display: 'block'});
        $('.loading').css({display: 'none'});
        if(action != null) {
          action();
        }
      })
    }
    } else {
      if($('.select2Q').val() == 'undefined' || $('.select2Q').val() == undefined || $('.select2Q').val() == '' || $('.select2Q').val() == null){
        alert('Plz Choose QUotation No');
      } else{
      this.idItem = id;
      $('.loading').css({display: 'block'});
      this._ApiService.getItemBooked({id: $('.select2Q').val()}).subscribe((res)=>{
        this.arre0987 = res;
        $('#upd023').css({display: 'block'});
        $('.loading').css({display: 'none'});
        if(action != null) {
          action();
        }
      })
    }
    }
  }
  ngOnInit(): void {
    $(document).ready(()=> {
    let self = this;
      $('.select2, .js-example-basic-multiple').select2();
      $('.goQN').on('select2:select', function (e: any) {
        self.yarbs0 = false;
        self.yarbs = $('.goQN').val();
        setTimeout(() => {
          self.yarbs0 = true;
        }, 100);
        self.arreCustomer.forEach((element: any) => {
          if(element.id == $('.goQN').val()){

            self.nameU = element.name;
            self.emailU = element.email;
            self.phoneU = '0' + element.phone;
            self.adressU = element.adress;
            self.idUS = element.id;
            self.cityU = element.city;
            self.areaU = element.area;
            self.typeU = element.type;
            self.phone2U = '0'+element.phone2
          }
        });
      })
      $('.goQN00X0').on('select2:select', function (e: any) {
        self.arreCustomer000.forEach((element0: any) => {
          if(element0.id == $('.goQN00X0').val()){
            self.nameU0 = element0.name;
            self.emailU0 = element0.email;
            self.phoneU0 = '0' + element0.phone;
            self.adressU0 = element0.adress;
            self.idUS0 = element0.id;
            self.cityU0 = element0.city;
            self.phone2U0 = element0.phone2;
          }
        });
      })
      $('.select2Q').on('select2:select', function (e: any) {
        self.nameU0 = '';
        self.phoneU0 = '';
        self.idUS0 = '';
        $('.delall').css({display: 'inline-block'})
        self.arre.forEach((element: any) => {
          if(element.id == $('.select2Q').val()){
            self.nameUX = element.sellername;
            $('.goQN00').val(element.seller_id).trigger('change.select2');
            self.nameUX0 = element.brokername;
            $('.goQN00X0').val(element.broker_id).trigger('change.select2');
            self.arreCustomer000.forEach((element0: any) => {
              if(element0.id == element.broker_id){
                self.nameU0 = element0.name;
                self.emailU0 = element0.email;
                self.phoneU0 = '0' + element0.phone;
                self.adressU0 = element0.adress;
                self.idUS0 = element0.id;
                self.cityU0 = element0.city;
                self.phone2U0 = element0.phone2;
                self.phone2U0 = '0'+element0.phone2;
              }
            });
          }
        });
        self.amount = 0;
        $('.loading').css({display: 'block'});
        self._ApiService.allCustomerP({id: $('.select2Q').val()}).subscribe((res)=>{
          if(res.check === true){
            let date0 = new Date(res.data[0].dateorder);
            let date0123 = new Date(res.data[0].date);
            self.dateAm = `Date : ${date0.getFullYear()+'-' + (date0.getMonth()+1) + '-'+date0.getDate()}`
            self.dateAmOrder = `Date QUotation :  ${date0123.getFullYear()+'-' + (date0123.getMonth()+1) + '-'+date0123.getDate()}`
            self.payAll = res.data[0].pay;
            self.commision = res.data[0].commssionbroker;
            setTimeout(() => {
              self.payAll00 = (self.alltotal - (self.alltotal * (self.discoundAll/100)));
              self.discoundAllValue = self.alltotal - self.payAll00;
            }, 100);
            self.alltotal = res.data[0].totalprice;
            self.discoundAll = res.data[0].discound;
            var price = self.alltotal / (1 - (self.commision / 100));
            self.price = price;
            self.commisionafter = price - self.alltotal;
            self._ApiService.allCustomerP0Id({id: $('.select2Q').val()}).subscribe((res0)=>{
              if(res0.check === true){
                res0.data.forEach((element: any) => {
                  self.amount = self.amount + element.pay
                });
                self.arre00 = res0.data;
                self.payAll0 = self.amount - (self.amount * ( self.discoundAll / 100));
                $('.select2QC').val(res.data[0].customer_id).trigger('change.select2');
                $('.goQN').val(res.data[0].customer_id).trigger('change.select2');
                self.yarbs0 = false;
        self.arreCustomer.forEach((element: any) => {
          if(element.id == $('.goQN').val()){

            self.nameU = element.name;
            self.emailU = element.email;
            self.phoneU = '0' + element.phone;
            self.adressU = element.adress;
            self.idUS = element.id;
            self.cityU = element.city;
            self.areaU = element.area;
            self.typeU = element.type;
            self.phone2U = '0'+element.phone2
          }
        });
                self.serchCodeVisit = $('.select2QC').val();
                self.choose = true;
                $('#fdgh').css({display: 'block'});
                $('.loading').css({display: 'none'});
              } else{
                alert('error');
                $('.loading').css({display: 'none'});
              }
            })
          } else{
            alert('error');
            $('.loading').css({display: 'none'});
          }
        })
        setTimeout(() => {
          $('#ostr').trigger('click');
        }, 400);
      });
      $('.selectPlusR').on('select2:select', function (e: any) {
        self.QtyAvaliable.forEach((element: any) => {
          if (element.place == $('.selectPlusR').val()) {
            self.ost = 'available quantity is ' +  element.qty;
          }
        });
      });
    var date = new Date();
    var day: any = date.getDate();
    var month: any = date.getMonth() + 1;
    var year = date.getFullYear();
    if (month < 10) month = "0" + month;
    if (day < 10) day = "0" + day;
    var today = year + "-" + month + "-" + day;
    $("#theDate").val(today);
    this.date = today;
    setTimeout(() => {
      let self = this;
      $('.select2, .js-example-basic-multiple').select2();
      $('.goQN').on('select2:select', function (e: any) {
        self.yarbs0 = false;
        self.yarbs = $('.goQN').val();
        setTimeout(() => {
          self.yarbs0 = true;
        }, 100);
        self.arreCustomer.forEach((element: any) => {
          if(element.id == $('.goQN').val()){

            self.nameU = element.name;
            self.emailU = element.email;
            self.phoneU = '0' + element.phone;
            self.adressU = element.adress;
            self.idUS = element.id;
            self.cityU = element.city;
            self.areaU = element.area;
            self.typeU = element.type;
            self.phone2U = '0'+element.phone2
          }
        });
      })
      $('.goQN00X0').on('select2:select', function (e: any) {
        self.arreCustomer000.forEach((element0: any) => {
          if(element0.id == $('.goQN00X0').val()){
            self.nameU0 = element0.name;
            self.emailU0 = element0.email;
            self.phoneU0 = '0' + element0.phone;
            self.adressU0 = element0.adress;
            self.idUS0 = element0.id;
            self.cityU0 = element0.city;
            self.phone2U0 = element0.phone2;
          }
        });
      })
      $('.select2Q').on('select2:select', function (e: any) {
        self.nameU0 = '';
        self.phoneU0 = '';
        self.idUS0 = '';
        $('.delall').css({display: 'inline-block'})
        self.arre.forEach((element: any) => {
          if(element.id == $('.select2Q').val()){
            self.nameUX = element.sellername;
            $('.goQN00').val(element.seller_id).trigger('change.select2');
            self.nameUX0 = element.brokername;
            $('.goQN00X0').val(element.broker_id).trigger('change.select2');
            self.arreCustomer000.forEach((element0: any) => {
              if(element0.id == element.broker_id){
                self.nameU0 = element0.name;
                self.emailU0 = element0.email;
                self.phoneU0 = '0' + element0.phone;
                self.adressU0 = element0.adress;
                self.idUS0 = element0.id;
                self.cityU0 = element0.city;
                self.phone2U0 = element0.phone2;
                self.phone2U0 = '0'+element0.phone2;
              }
            });
          }
        });
        self.amount = 0;
        $('.loading').css({display: 'block'});
        self._ApiService.allCustomerP({id: $('.select2Q').val()}).subscribe((res)=>{
          if(res.check === true){
            let date0 = new Date(res.data[0].dateorder);
            let date0123 = new Date(res.data[0].date);
            self.dateAm = `Date : ${date0.getFullYear()+'-' + (date0.getMonth()+1) + '-'+date0.getDate()}`
            self.dateAmOrder = `Date QUotation :  ${date0123.getFullYear()+'-' + (date0123.getMonth()+1) + '-'+date0123.getDate()}`
            self.payAll = res.data[0].pay;
            self.commision = res.data[0].commssionbroker;
            setTimeout(() => {
              self.payAll00 = (self.alltotal - (self.alltotal * (self.discoundAll/100)));
              self.discoundAllValue = self.alltotal - self.payAll00;
            }, 100);
            self.alltotal = res.data[0].totalprice;
            self.discoundAll = res.data[0].discound;
            var price = self.alltotal / (1 - (self.commision / 100));
            self.price = price;
            self.commisionafter = price - self.alltotal;
            self._ApiService.allCustomerP0Id({id: $('.select2Q').val()}).subscribe((res0)=>{
              if(res0.check === true){
                res0.data.forEach((element: any) => {
                  self.amount = self.amount + element.pay
                });
                self.arre00 = res0.data;
                self.payAll0 = self.amount - (self.amount * ( self.discoundAll / 100));
                $('.select2QC').val(res.data[0].customer_id).trigger('change.select2');
                $('.goQN').val(res.data[0].customer_id).trigger('change.select2');
                self.yarbs0 = false;
        self.arreCustomer.forEach((element: any) => {
          if(element.id == $('.goQN').val()){

            self.nameU = element.name;
            self.emailU = element.email;
            self.phoneU = '0' + element.phone;
            self.adressU = element.adress;
            self.idUS = element.id;
            self.cityU = element.city;
            self.areaU = element.area;
            self.typeU = element.type;
            self.phone2U = '0'+element.phone2
          }
        });
                self.serchCodeVisit = $('.select2QC').val();
                self.choose = true;
                $('#fdgh').css({display: 'block'});
                $('.loading').css({display: 'none'});
              } else{
                alert('error');
                $('.loading').css({display: 'none'});
              }
            })
          } else{
            alert('error');
            $('.loading').css({display: 'none'});
          }
        })
        setTimeout(() => {
          $('#ostr').trigger('click');
        }, 400);
      });
      $('.selectPlusR').on('select2:select', function (e: any) {
        self.QtyAvaliable.forEach((element: any) => {
          if (element.place == $('.selectPlusR').val()) {
            self.ost = 'available quantity is ' +  element.qty;
          }
        });
      });
    var date = new Date();
    var day: any = date.getDate();
    var month: any = date.getMonth() + 1;
    var year = date.getFullYear();
    if (month < 10) month = "0" + month;
    if (day < 10) day = "0" + day;
    var today = year + "-" + month + "-" + day;
    $("#theDate").val(today);
    this.date = today;
    }, 5000);
    });
  }

}
